/**
 * Modal horizontal de lanzamiento AdvPro (webinar del miércoles 5 de agosto de
 * 2026). Invita a los clientes que siguen en v2 a reservar lugar en el webinar
 * vía el formulario de ClickUp.
 *
 * Comportamiento (solo admins, y solo en empresas no excluidas — ver
 * `excludedCompanies.constants.ts`):
 *  - CTA "Reservar mi lugar gratis" → descarte permanente por company,
 *    persistido en DB (`companies.advpro_launch_dismissed`, cross-device).
 *  - Aparece **una vez cada 7 días por persona** (ADV-3347, regla de toda la
 *    familia: ver `specialModalFrequency.constants.ts`). Cerrar (X) o "Ahora
 *    no" solo cierran la vista: la ventana ya se abrió al mostrarlo.
 *  - Ventana: desde el deploy hasta el 5 de agosto INCLUSIVE (fin del día en
 *    México, UTC-6, la TZ más al oeste de la audiencia).
 *
 * Hasta ADV-3347 cerrar posponía el modal 1 hora (`advpro_launch_snooze`, por
 * navegador). Esa marca ya no se lee ni se escribe.
 */

import { isExcludedFromSpecialModals } from 'constants/excludedCompanies.constants';
import {
  SpecialModalUserId,
  wasSpecialModalShownRecently
} from 'constants/specialModalFrequency.constants';

/** Corte de visibilidad: 5-ago-2026 23:59:59 hora México (UTC-6). */
export const ADVPRO_LAUNCH_END_DATE = '2026-08-05T23:59:59-06:00';

/** Formulario de ClickUp para reservar lugar en el webinar. */
export const ADVPRO_LAUNCH_FORM_URL =
  'https://forms.clickup.com/4662065/f/4e8th-179557/W1YN2QPTKYPM1T62C4';

/** Video de presentación (se embebe con autoplay al tocar el poster). */
export const ADVPRO_LAUNCH_VIDEO_EMBED_URL =
  'https://www.youtube.com/embed/zgTyl2eVupM';

/** Key de este modal para la marca de frecuencia de la familia. */
export const ADVPRO_LAUNCH_MODAL_KEY = 'advpro_launch';

/**
 * Decide si el modal de lanzamiento debe mostrarse: campaña vigente + empresa
 * no excluida + company sin descarte permanente (DB) + ventana de frecuencia
 * vencida para esta persona.
 */
export const shouldShowAdvproLaunchModal = (
  dismissedForCompany: boolean | undefined,
  userId: SpecialModalUserId
): boolean => {
  // Sin id no hay forma de recordar la última aparición: mostrarlo
  // significaría reaparecer en cada carga.
  if (userId === undefined || userId === null || userId === '') return false;
  if (Date.now() >= new Date(ADVPRO_LAUNCH_END_DATE).getTime()) return false;
  if (isExcludedFromSpecialModals()) return false;
  if (dismissedForCompany === true) return false;
  if (wasSpecialModalShownRecently(ADVPRO_LAUNCH_MODAL_KEY, userId)) {
    return false;
  }
  return true;
};
